<template>
  <div>
    <GNavBar></GNavBar>
    <b-container class="mt-5 pt-5">
      <h1>Administration</h1>
      <hr />
      <b-row align-h="center">
        <b-col cols="8">
          <b-alert variant="warning" show>
            <h4 class="alert-heading">Operate with care</h4>
            <p>Admin functions are 💪.</p>
          </b-alert>
        </b-col>
      </b-row>
      <div v-if="this.$route.params.adminFunction === 'impersonate'">
        <b-row align-h="center">
          <b-col md="8">
            <h2>Impersonate user</h2>
            <p>
              Select a user to impersonate from the dropdown. You will see the
              application as they do and will appear as that user to the
              application
              <em>and</em> the database.
            </p>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col md="8">
            <GMockLogin />
          </b-col>
        </b-row>
      </div>
      <div v-if="this.$route.params.adminFunction === 'assign-lead'">
        <b-row align-h="center">
          <b-col md="8">
            <h2>Assign OFDIT lead</h2>
            <p>
              Below are all of the projects whose status is currently set to
              <em>Contract executed</em>. To assign a lead, use the dropdown to
              select from current OFDIT staff and press submit.
            </p>
            <p>This will:</p>
            <ul>
              <li>
                Change the status of the project to
                <em>Course in development</em>.
              </li>
              <li>
                Send an email to the assigned lead
                <em>if the lead has been changed</em>.
              </li>
              <li>
                Add a comment to the interaction log reflecting the change in
                status and lead. You may add additional (optional) comments.
                <em>
                  These comments will appear in both the interaction log and the
                  email sent to the assigned lead.</em
                >
              </li>
            </ul>
            <p>
              Projects to be assigned:
              <strong>{{ projectsToBeAssigned.length }}</strong>
            </p>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col md="10">
            <GAssignLeads />
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  import GMockLogin from '@/components/GMockLogin'
  import GAssignLeads from '@/components/GAssignLeads.vue'
  import GNavBar from '@/components/GNavBar.vue'

  export default {
    name: 'AdminPage',
    components: {
      GMockLogin,
      GAssignLeads,
      GNavBar
    },
    created() {
      this.$store.dispatch('getUserList')
    },
    data() {
      return {}
    },
    computed: {
      currentUser() {
        return this.$store.getters.currentUser
      },
      projectsToBeAssigned() {
        return this.$store.getters.projectsToBeAssigned
      }
    }
  }
</script>
